<template>
    <v-text-field
        v-model="valueComp"
        :name="name"
        :disabled="disabled"
        :error-messages="errors.collect(name)"
        :placeholder="placeholder"
        v-validate="retornaValidacao"
        :data-vv-as="name"
        @blur="aoSairCampoValidarEAtualizarValor"
        @keypress="aoPressTeclaNaoPermitirValoresInvalidos"
        @paste="aoColarValor($event)"
        v-on:keyup.enter="aoPressTeclaEnter"
        v-on:keyup.esc="aoPressTeclaEsc">
        <template v-if="label" v-slot:label>
            {{ label }}
            <span v-if="required" class="ml-1 red--text">*</span>
        </template>
        <template v-else-if="campo && tela" v-slot:label>
            <label-personalizado :campo="campo" :tela="tela" :complemento-label="complementoLabel"
                                 :permissao-edicao="permissaoEdicao" :obrigatorio-por-padrao="required"/>
        </template>
        <template v-slot:append>
            <span class="texto-prefix-suffix">{{suffix}}</span>
            <slot name="append"/>
        </template>
        <template v-slot:prepend-inner>
            <span class="texto-prefix-suffix">{{prefix}}</span>
        </template>
    </v-text-field>
</template>

<script>
    import LabelPersonalizado from '@/views/components/label/LabelPersonalizado'
    export default {
        inject: ['$validator'],
        name: 'CampoInteiro',
        components: {LabelPersonalizado},
        model: { prop: 'value', event: 'input' },
        props: {
            value: {
                type: [String, Number],
                default: ''
            },
            name: {
                required: true,
                type: String
            },
            label: {
                type: String,
                default: ''
            },
            maxnumber: {
                type: Number,
                default: 100
            },
            minnumber: {
                type: Number,
                default: 0
            },
            placeholder: {
                type: String
            },
            disabled: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            },
            prefix: {
                type: String,
                default: ''
            },
            suffix: {
                type: String,
                default: ''
            },
            campo: {
                type: String,
                default: ''
            },
            tela: {
                type: String,
                default: ''
            },
            complementoLabel: {
                type: String,
                default: ''
            },
            permissaoEdicao: {
                type: Boolean,
                default: true
            },
            mensagemObrigatoriedade: {
                type: String,
                default: 'O valor deve ser maior ou igual a'
            }
        },
        created() {
            this.$validator.extend(
                'minnumber',{
                    getMessage: () => this.mensagemObrigatoriedade + ' ' + this.minnumber,
                    validate: (value) => {
                        return value >= this.minnumber
                    }
                })
        },
        computed: {
            valueComp: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', this.formatarParaModel(value))
                }
            },
            maxlength() {
                const maxnumberStr = this.maxnumber.toString()
                if (maxnumberStr.indexOf('.') === -1) return maxnumberStr.length
                return maxnumberStr.split('.')[0].length
            },
            retornaValidacao() {
                let validacoes = []
                if (this.required) validacoes.push('required')
                if (this.minnumber) validacoes.push('minnumber')
                return validacoes.join('|')
            }
        },
        methods: {
            formatarParaModel(numero) {
                if (!numero) return ''
                numero = this.removerCharsEZerosAEsquerda(numero)
                if (isNaN(numero)) return ''
                return numero
            },
            aoPressTeclaNaoPermitirValoresInvalidos($event) {
                let keyCode = $event.keyCode ? $event.keyCode : $event.which
                if (keyCode < 48 || keyCode > 57) {
                    $event.preventDefault()
                }
                if (this.valorEhMaiorQuePermitido()) {
                    $event.preventDefault()
                }
            },
            removerCharsEZerosAEsquerda(value) {
                if (!value) return ''
                return value.toString().replace(/[^0-9]/g, '').replace(/^0+/, '')
            },
            valorEhMaiorQuePermitido() {
                return Number(this.removerCharsEZerosAEsquerda(this.value).length) >= this.maxlength
            },
            aoSairCampoValidarEAtualizarValor() {
                if (parseFloat(this.value) <= this.minnumber) this.$emit('input', this.minnumber)
                else if (parseFloat(this.value) >= this.maxnumber) this.$emit('input', this.maxnumber)
                this.$emit('blur')
            },
            aoPressTeclaEnter() {
                this.$emit('keyupEnter')
            },
            aoPressTeclaEsc() {
                this.$emit('keyupEsc')
            },
            aoColarValor(event) {
                this.$emit('input', this.formatarParaModel(event.clipboardData.getData('text')))
                event.target.blur()
            }
        }
    }
</script>

<style lang="stylus">
</style>
